import React from "react";
import "./SkillsInfo.css";

const PassivaInfo = () => {
  return (
    <>
      <p className="skill__key">PASSIVE </p>
      <h5 className="skill_name">MORTAL WILL</h5>
      <p className="skill_infos">
        Every few spells or attacks, Pantheon's next spell is empowered.
      </p>
    </>
  );
};

export default PassivaInfo;
